import { render, staticRenderFns } from "./second_menuComputer_JingPin.vue?vue&type=template&id=70f2f563&scoped=true"
import script from "./second_menuComputer_JingPin.vue?vue&type=script&lang=js"
export * from "./second_menuComputer_JingPin.vue?vue&type=script&lang=js"
import style1 from "./second_menuComputer_JingPin.vue?vue&type=style&index=1&id=70f2f563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2f563",
  null
  
)

export default component.exports